import { clearLocalStorageBasedOnBodyAttr } from 'root/utils/dom/localStorage';
import TrackingCookies from 'root/core/tracking/trackingCookies/trackingCookies';
import AnchorsScrolling from 'root/core/anchorsScrolling';
import { handleYoutubeLightboxesOnDocumentClick } from 'root/main/components/mediaLightbox/youtubeLightbox';
import { swapLightboxFormLinksForWizard } from 'root/core/wizardLinkSwapping';
import { swapRetailFreeTrialLinksForAccountsRedirect } from 'root/core/retailFreeTrialRedirect';
import {
    trackRestaurantProductOnLoadViaDataAttribute,
    trackRestaurantProductInURL,
} from 'root/core/restaurantProductTracking/restaurantProductTracking';
import { setCookieBasedOnKountaParam } from 'root/core/kounta';
import { populateESeriesLinkParams } from 'root/core/eSeriesLinkSwapping';
import { removeEcomFromPCPages } from 'root/core/removeEcomFromPCPages';
import resetTitlesHeightToTallest from 'root/utils/resetTitlesHeightToTallest';
import { populateFootnoteSection } from 'root/core/footnoteSection';
import { initCookiePreferencesButton } from 'root/core/OneTrustControllers';
import sessionTracking from 'root/core/tracking/sessionTracking/sessionTracking';
import { trackGeoConfigSource } from 'root/core/tracking/geoConfigSourceTracking/geoConfigSourceTracking';
import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';
import {
    bindTalkToExpertLandingPageCTAs,
    handleSSBORedirectPageSeenEvent,
} from './tracking/ssboRedirectTracking';

function CoreDom() {
    TrackingCookies();
    AnchorsScrolling();
    handleYoutubeLightboxesOnDocumentClick();
    // Order matters: wizardLinkSwapping must run first to add the -wizard-lightbox suffix,
    // then retailFreeTrialRedirect can find those suffixed links and swap their href.
    swapLightboxFormLinksForWizard();
    swapRetailFreeTrialLinksForAccountsRedirect();
    trackRestaurantProductOnLoadViaDataAttribute();
    trackRestaurantProductInURL();
    populateESeriesLinkParams();
    removeEcomFromPCPages();
    populateFootnoteSection();
    initCookiePreferencesButton();
    bindTalkToExpertLandingPageCTAs();
}

function CoreLoad() {
    clearLocalStorageBasedOnBodyAttr();
    setCookieBasedOnKountaParam();
    resetTitlesHeightToTallest();
    sessionTracking();
    trackGeoConfigSource();
    handleSSBORedirectPageSeenEvent();
}

function buttonTrackingHandler(e) {
    import(
        /* webpackChunkName: "buttonTracking" */ 'root/core/tracking/buttonTracking/buttonTracking'
    )
        .then(module => new module.default().sendEventHandler(e))
        .catch(error => {
            if (error && error.name === 'ChunkLoadError') {
                LoggingHandler().logError(error.message, {
                    searchTerm: 'buttonTracking',
                    fileName: 'buttonTracking.js',
                });
            }
        });
}

export { CoreDom, CoreLoad, buttonTrackingHandler };
